import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Fishermans Bend – Reticulation Pipes</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
          We’ll design and facilitate the roll out of reticulation pipes reticulation pipes to bring recycled water from the Fishermans Bend Water Recycling Plant via the Recycled Water Mains to apartments, buildings and green spaces along the proposed alignment. 
        </p>
        <p>
          The reticulation pipes will be constructed throughout the Montague, Lorimer, Sandridge, Wirraway, and Employment precincts that will connect apartments, buildings and green spaces to the recycled water distribution network. 
        </p>
        <p>
          The reticulation pipes will be delivered progressively over time to connect new customers.  
        </p>
        <p>
          For more project information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/projects/fishermans-bend/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MORE INFO: Fishermans Bend - Reticulation Pipes',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800055465">1800 055 465</a> |{' '}
          <a
            href="mailto:FishermansBend@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: 'Map – Major Projects (purple)',
                action: '<a href> link',
                label:
                  'MAIL TO: FishermansBend@sew.com.au - Fishermans Bend - Reticulation Pipes',
              });
            }}
          >
            FishermansBend@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
